<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>公司汽车保养登记使用说明:<br>
					<span>1、单号构成规则:201201+BY+4位顺序号。系统生成,添加无效</span><br>
					<span>2、由录入人员录入保养费用，确定经办人。当提交后，由经办人申请相关费用报销。</span><br>
					<span>3、如果配件总金额没有填写，则配件总金额=配件数量*配件单价。</span><br>
					<span>4、查询关键字:单号、车牌号、状态、保养日期范围、修改日期范围。</span><br>
					<span>5、工时费和材料费不能修改，通过合计明细来计算。</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="pre_base_button">

        <button class="pre_btn_ok" @click="refresh_data('1')">查询待完成</button>
      </template> -->
			<template slot="slot_c_flag">
				<pre-select class="short0" @selectFunc="selectFunc0" v-bind:searchList="t_list_flag"
					:selectValue="sel_flag" />
			</template>
			<template slot="slot_c_user">
				<pre-select class="short0" @selectFunc="selectFunc" v-bind:searchList="list_user"
					:selectValue="sel_user" />
			</template>
			<template slot="slot_c_car">
				<pre-select class="short0" @selectFunc="selectFunc1" v-bind:searchList="list_car"
					:selectValue="sel_car" />
			</template>
			<template slot="slot_c_carbm">
				<pre-select class="short0" @selectFunc="selectFunc3" v-bind:searchList="list_carbm"
					:selectValue="sel_carbm" />
			</template>
			<template slot="slot_c_outclass">
				<pre-select class="short0" @selectFunc="selectFunc2" v-bind:searchList="list_out"
					:selectValue="sel_out" />
			</template>
		</pre-base>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../per_old/pre_base_table_3.vue"),
			'pre-select': () => import("../per_old/pre_select_one.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: '',
				// 下拉菜单

				t_list_flag: [],
				sel_flag: {},

				list_car: [],
				list_car_bak: [],
				sel_car: {},

				list_user: [],
				list_user_bak: [],
				sel_user: {},
				list_out: [],
				sel_out: {},

				list_carbm: [],
				list_carbm_bak: [],
				sel_carbm: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// //事故附件操作老方法 carBY
				
				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '汽车保养',
					"control": "carMaintenance",
					"sel_action": 'exp_car_carMaint',
					"upd_action": 'car_carMaintenance',
					"d_title_name": '汽车保养费用合计',
					"d_sel_action": 'exp_car_carFile',
					"d_upd_action": 'car_carFile',
					"file_action": 'filemore',
					"p1": 'car',
					"p2": 'by',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"slot": "slot_c_car",
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "挂车别名",
							"val": "",
							"key": "cp_no",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"slot": "slot_c_carbm",
							"sel_name": "",
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"slot": "slot_c_flag",
							"sel_name": "",
							"sel": "4"
						},
						{
							"name": "开始保养日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "截止保养日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "开始修改日期",
							"val": "",
							"key": "s_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "截止修改日期",
							"val": "",
							"key": "e_sys_date",
							"type": "date",
							"class": "long1",
							"sel": "8"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "车牌号码",
							"val": "",
							"key": "c_no",
							"type": "select",
							"class": "long1",
							"weight": "1",
							"slot": "slot_c_car",
							"sel_name": "",
							"p": "1"
						},
						{
							"name": "挂车别名",
							"val": "",
							"key": "cp_no",
							"type": "select",
							"class": "long1",
							"weight": "0",
							"slot": "slot_c_carbm",
							"sel_name": "",
							"p": "1"
						},
						{
							"name": "保养项目",
							"val": "",
							"key": "c_name",
							"type": "none",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "保养日期",
							"val": "",
							"key": "c_date",
							"type": "date",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "保养时公里数",
							"val": "",
							"key": "c_distance",
							"type": "number",
							"class": "long1",
							"p": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"slot": "slot_c_user",
							"sel_name": "",
							"p": "1"
						}
					],
					"parm_th": [{
							"name": "序号"
						}, {
							"name": "单号"
						}, {
							"name": "车牌号码"
						},
						{
							"name": "挂车别名"
						},
						// {
						//   "name": "保养项目"
						// },
						{
							"name": "总费用"
						},
						{
							"name": "保养日期"
						},
						{
							"name": "保养时里程"
						},
						{
							"name": "备注"
						},
						{
							"name": "附件"
						},
						{
							"name": "经办人"
						},
						{
							"name": "明细"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "修改日期"
						}
					],
					"d_parm": [{
							"name": "单号",
							"val": '',
							"key": "sheet_no",
							"type": "none"
						},
						{
							"name": "略",
							"val": '',
							"key": "f_note",
							"type": "none",
							"weight": "0"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "i_name",
							"type": "select",
							"first": "isfirst",
							"class": "long1",
							"slot": "slot_c_outclass",
							"sel_name": "",
							"weight": "1"
						},
						{
							"name": "略",
							"val": "",
							"key": "f_date",
							"type": "none",
							"class": "long1",
							"weight": "0"
						},
						{
							"name": "费用金额",
							"val": "",
							"key": "amount",
							"type": "number",
							"weight": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},

						{
							"name": "费用名称"
						},
						{
							"name": "费用金额"
						},
						{
							"name": "有无附件"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改日期"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "访问地址"
						}
					],
					"d1_title_name": '汽车保养项目',
					"d1_sel_action": 'exp_car_p_name',
					"d1_upd_action": 'car_p_name',
					"d1_parm": [{
							"name": "单号",
							"val": '',
							"key": "sheet_no",
							"type": "none"
						},
						{
							"name": "项目名称",
							"val": '',
							"key": "f_name",
							"type": "text",
							"first": "isfirst",
							"class": "long1",
							"weight": "1"
						},
						{
							"name": "工时费用",
							"val": "",
							"key": "f_amount",
							"type": "number",
							"class": "long1",
							"weight": "1"
						},
						{
							"name": "施工人员",
							"val": "",
							"key": "f_user",
							"type": "text",
							"class": "long1",
							"weight": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "f_note",
							"type": "text",
							"class": "long1",
							"weight": "0"
						}
					],
					"d1_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "保养项目"
						},
						{
							"name": "工时费用"
						},
						{
							"name": "施工人员"
						},
						{
							"name": "备注"
						},
						{
							"name": ""
						},
						{
							"name": ""
						}
					],
					"d2_title_name": '汽车保养配件明细',
					"d2_sel_action": 'exp_car_p_item',
					"d2_upd_action": 'car_p_item',
					"d2_parm": [{
							"name": "单号",
							"val": '',
							"key": "sheet_no",
							"type": "none"
						},
						{
							"name": "配件名称",
							"val": '',
							"key": "f_name",
							"type": "text",
							"first": "isfirst",
							"class": "long2",
							"weight": "1"
						},
						{
							"name": "型号",
							"val": "",
							"key": "f_size",
							"type": "text",
							"class": "long1",
							"weight": "0"
						},
						{
							"name": "单位",
							"val": "",
							"key": "f_unit",
							"type": "text",
							"class": "long1",
							"weight": "0"
						},
						{
							"name": "数量",
							"val": "",
							"key": "f_qty",
							"type": "number",
							"class": "long1",
							"weight": "1"
						},
						{
							"name": "单价",
							"val": "",
							"key": "f_price",
							"type": "number",
							"class": "long1",
							"weight": "1"
						},
						{
							"name": "实际总金额",
							"val": "",
							"key": "f_amount",
							"type": "number",
							"class": "long1",
							"weight": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "f_note",
							"type": "text",
							"class": "long1",
							"weight": "0"
						}
					],
					"d2_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "单号"
						},
						{
							"name": "配件名称"
						},
						{
							"name": "型号"
						},
						{
							"name": "单位"
						},
						{
							"name": "数量"
						},
						{
							"name": "单价"
						},
						{
							"name": "实际总金额"
						},
						{
							"name": "备注"
						},
						{
							"name": ""
						},
						{
							"name": ""
						}
					]
				});

				this.loadUser();
				this.loadInClass();
				this.loadSelectData();
				this.loadflag();
				this.loadSelectDatabm();
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_children: function(type, id, val) {
				var that = this;
				if (type == 'slot_c_user') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'main');
					});
				} else if (type == 'slot_c_car') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'main');
					});
				} else if (type == 'slot_c_carbm') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'main');
					});
				} else if (type == 'slot_c_outclass') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'children');
					});
				} else if (type == 'slot_c_flag') {
					this.$nextTick(function() {
						that.$refs['mybase'].refesh_parm(type, id, val, 'main');
					});
				} else {
					this.$message({
						message: '类别=!' + type + ' 没有配置相关操作!',
						type: 'error'
					});
				}
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					case 'slot_c_flag':
						this.selectFunc0(val);
						break;
					case 'slot_c_user':
						this.selectFunc(val);
						break;
					case 'slot_c_car':
						this.selectFunc1(val, 'father');
						break;
					case 'slot_c_carbm':
						this.selectFunc3(val);
						break;
					case 'slot_c_outclass':
						this.selectFunc2(val);
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			/*****************************************************/
			/*****************************************************/
			selectFunc0: function(value) {
				// console.log('选择结果='+parm);
				for (var i = 0; i < this.t_list_flag.length; i++) {
					if (this.t_list_flag[i].id == value || this.t_list_flag[i].val == value) {
						this.refresh_children('slot_c_flag', this.t_list_flag[i].id, this.t_list_flag[i].val)
						break;
					}
				}
			},
			selectFunc: function(sel_id, sel_val) {
				// console.log('选择结果='+parm);
				let tflag = false;

				for (var i = 0; i < this.list_user.length; i++) {
					if (this.list_user[i].id == sel_id && this.list_user[i].val == sel_val) {
						tflag = true;
						console.log('选择匹配=' + this.list_user[i].id + ' val=' + this.list_user[i].val);
						this.refresh_children('slot_c_user', this.list_user[i].id, this.list_user[i].val);
						break;
					}
				}

				if (!tflag) {
					// console.log('开始模糊查询');

					this.list_user = [];
					for (var i = 0; i < this.list_user_bak.length; i++) {
						if (this.list_user_bak[i].val.indexOf(sel_id) >= 0) {
							this.list_user.push(this.list_user_bak[i]);
						}
					}
					if (this.list_user.length == 0) {
						this.list_user = this.list_user_bak;
					}
				} else {
					this.list_user = [];
					this.list_user = this.list_user_bak;
				}
			},
			selectFunc1: async function(sel_id, sel_val) {
				// console.log('选择结果1=' + sel_id + ' val=' + sel_val);
				// console.log(this.list_car)
				//按字段模糊查询
				let tflag = false;

				for (var i = 0; i < this.list_car.length; i++) {
					if (sel_val == 'father') {
						if (this.list_car[i].val == sel_id) {
							tflag = true;
							this.refresh_children('slot_c_car', this.list_car[i].id, this.list_car[i].val);
							break;
						}
					} else {
						if (this.list_car[i].id == sel_id && this.list_car[i].val == sel_val) {
							tflag = true;
							this.loadSelectDatabm(sel_val);
							this.refresh_children('slot_c_car', this.list_car[i].id, this.list_car[i].val);
							break;
						}
					}
				}

				if (!tflag) {
					this.list_car = [];
					for (var i = 0; i < this.list_car_bak.length; i++) {
						if (this.list_car_bak[i].val.indexOf(sel_id) >= 0) {
							this.list_car.push(this.list_car_bak[i]);
						}
					}
					// console.log('选择结果车牌=' + sel_id + ' val=' + sel_val);
					// console.log(this.list_car);
					if (this.list_car.length == 0) {
						this.list_car = this.list_car_bak;
					}
				} else {
					this.list_car = [];
					this.list_car = this.list_car_bak;
				}
			},
			selectFunc2: function(value) {
				// console.log('选择结果='+value);
				for (var i = 0; i < this.list_out.length; i++) {
					if (this.list_out[i].id == value || this.list_out[i].val == value) {
						this.refresh_children('slot_c_outclass', this.list_out[i].id, this.list_out[i].val)
						break;
					}
				}
			},
			selectFunc3: function(value) {
				// console.log('别名查询='+value);
				if (typeof(value) !== 'undefined' && value != '') {
					console.log('别名匹配=' + value);

					for (var i = 0; i < this.list_carbm.length; i++) {
						if (this.list_carbm[i].id == value || this.list_carbm[i].val == value) {
							this.refresh_children('slot_c_carbm', this.list_carbm[i].id, this.list_carbm[i].val)
							break;
						}
					}
				}

			},
			loadUser: function() {
				this.list_user = [];
				this.list_user_bak = [];
				this.$post(
					api.http_method, Method_EasySelect('data_alluser', '')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					if (res.data.status == 1) {
						this.list_user = res.data.data;
						this.list_user_bak = res.data.data;
					}
				});
			},
			loadflag: function() {
				this.t_list_flag = [];
				this.$post(
					api.http_method, Method_EasySelect('data_flag', '')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					if (res.data.status == 1) {
						this.t_list_flag = res.data.data;
					}
				});
			},
			loadInClass: function() {
				this.list_out = [];
				this.$post(
					api.http_method, Method_EasySelect('data_out_classok', 'BY')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					if (res.data.status == 1) {
						this.list_out = res.data.data;
					}
				});
			},
			loadSelectData: function() {
				this.list_car = [];
				this.list_car_bak = [];
				this.$post(
					api.http_method, Method_EasySelect('data_exp_car', '1')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					if (res.data.status == 1) {
						this.list_car = res.data.data;
						this.list_car_bak = res.data.data;
					}
				});
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			loadSelectDatabm: function(car_no) {
				this.list_carbm = [];
				this.list_carbm_bak = [];
				this.$post(
					api.http_method, Method_EasySelect('_base_car_bm', car_no)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.list_carbm = res.data.data;
						this.list_carbm_bak = res.data.data;
					}
				});
			}


		}
	};
</script>
<style scoped>


</style>